module.exports = __webpack_public_path__ + "img/remove.f0de74c8.svg";